import { Component, OnInit, Renderer2, ElementRef, ViewChild, AfterContentInit, Input, ViewContainerRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'dhhp-card',
  template: `<mat-card #refCard>
  <ng-content></ng-content>
</mat-card>`
})
export class DhhpCardComponent implements OnInit, AfterViewInit {
  @Input()value:string;
  /**
   * Analytics Properties
   */
  @Input() indexable:boolean=false;
  @Input() extendible:boolean=false;
  @Input() localizable:boolean=false;
  @Input() filterable:boolean=false;
  @Input() searchable:boolean=false;
  @Input() sortable:boolean=false;
  @Input() analyzable:boolean=false;
  @Input() displayable:boolean=false;
  @Input() auditable:boolean=false;
  @Input() loggable:boolean=false;
  @Input() class:string;
  @ViewChild("refCard", {read: ElementRef}) refCard: ElementRef;
  constructor(private renderer:Renderer2, private el:ViewContainerRef) { }
  
  ngOnInit() {
  }
  analyticProperties(){
    this.renderer.setAttribute(this.refCard.nativeElement, 'indexable', this.getAnalyticValue(this.indexable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'extendible', this.getAnalyticValue(this.extendible));
    this.renderer.setAttribute(this.refCard.nativeElement, 'localizable', this.getAnalyticValue(this.localizable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'filterable', this.getAnalyticValue(this.filterable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'searchable', this.getAnalyticValue(this.searchable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'sortable', this.getAnalyticValue(this.sortable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'analyzable', this.getAnalyticValue(this.analyzable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'displayable', this.getAnalyticValue(this.displayable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'auditable', this.getAnalyticValue(this.auditable));
    this.renderer.setAttribute(this.refCard.nativeElement, 'loggable', this.getAnalyticValue(this.loggable));
  }
  getAnalyticValue(value:boolean):any{
    return value ? true : false;
  }
  ngAfterViewInit(){
    this.analyticProperties();
    this.class = this.class + ' mat-card';
    this.renderer.setAttribute(this.refCard.nativeElement, 'class',this.class);
    this.renderer.setAttribute(this.refCard.nativeElement,'_ngcontent-c6','')
    this.renderer.setAttribute(this.refCard.nativeElement.parentNode,'class','')
  }

}
